import React, { useState } from "react";
import {
  Tabs,
  Table,
  Empty,
  Tag,
  Typography,
  Modal,
  message,
  Button,
  Spin,
  Card,
  Descriptions,
  Collapse,
  Tooltip,
  Checkbox
} from "antd";
import { DownloadOutlined, DeleteOutlined,FolderOpenOutlined  } from "@ant-design/icons";
import "./Details.css";
import DupliTextParent from "../../components/MyOrderActions/DupliTextParent";
import orderService from "../../services/OrderLists";
import { useParams } from "react-router-dom";
import usePermissions from "../../hooks/usePermissions";
import useIsMobile from "../../hooks/useIsMobile";
import moment from "moment";

import SolutionFilesMobile from "./SolutionMobileViewComponent";
import { linearGradient } from "framer-motion/client";
import DupliTextDetail from "./DuplitextDetail";
import { render } from "@testing-library/react";
import FeedbbackDesktop from "../../components/FeedbackEvaluation/FeedbbackDesktop";
import FeedbackEvalMobile from "../../components/FeedbackEvaluation/FeedbackEvalMobile";
const { TabPane } = Tabs;
const SolutionFilesAccordion = ({
  finalFilesData = [],
  similarityReportData = [],
  otherFilesData = [],
  solutionDetails = [],
  setSolutionFiles,
  solutionFiles,
  isClientVerified,
  fetchOrderDetails,

}) => {
  const { Panel } = Collapse;
  const isMobile = useIsMobile(); // Check if device is mobile
  const { hasPermission } = usePermissions();
  const { orderKey } = useParams();
  const [deletingFileUid, setDeletingFileUid] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);

  const [isDuplitextVisible, setIsDuplitextVisible] = useState(false);
  const [activeKey, setActiveKey] = useState("1");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isReferencingModalVisible, setIsReferencingModalVisible] =
    useState(false);
  const [referencingIssuesData, setReferencingIssuesData] = useState();
  const [isFeedbackModalVisible, setIsFeedbackModalVisible] = useState(false);
  const [feedbackReportData, setFeedbackReportData] = useState();
  const [copyscapeUid, setCopyscapeUid] = useState(null);
  const [isMetaFileModalVisible, setIsMetaFileModalVisible] = useState(false);
  const [metaFileData, setMetaFileData] = useState(null);

  const handleOpenDuplitext = (uid) => {
    setCopyscapeUid(uid);
    setIsDuplitextVisible(true);
  };

  const handleDelete = async (orderKey, del_obj, tabKey) => {
    console.log(solutionFiles);
    console.log("hello");
    try {
      setDeletingFileUid(del_obj[0]); // Track the specific file being deleted
      const payload = { del_obj };
      const response = await orderService.deleteSolutionFile(orderKey, payload);

      if (response.success) {
        message.success("File deleted successfully");
        fetchOrderDetails();

        // Update the corresponding file list based on the tab
        setSolutionFiles((prev) => {
          if (!prev) return prev; // Guard clause if prev is undefined
          return {
            ...prev,
            finalFilesData:
              tabKey === "1"
                ? prev.finalFilesData.filter(
                    (file) => !del_obj.includes(file.file_uid)
                  )
                : prev.finalFilesData,
            similarityReportData:
              tabKey === "2"
                ? prev.similarityReportData.filter(
                    (file) => !del_obj.includes(file.file_uid)
                  )
                : prev.similarityReportData,
            otherFilesData:
              tabKey === "3"
                ? prev.otherFilesData.filter(
                    (file) => !del_obj.includes(file.file_uid)
                  )
                : prev.otherFilesData,
          };
        });
      } else {
        message.error("Failed to delete file");
      }
    } catch (err) {
      console.error("Error during file deletion:", err);
      message.error("An error occurred while deleting file");
    } finally {
      setDeletingFileUid(null); // Reset after completion
    }
  };

  const renderTable = (data) => {
    // console.log(data, "data is here ");
    // Format each date in the data array
    const formattedData = data.map((item) => ({
      ...item,
      created: moment(item.created).local().format("YYYY-MM-DD hh:mm A"),
    }));

    // console.log("actovekeye",activeKey)
    return (
      <Table
        style={{ width: "100%" }}
        columns={[
          {
            title: "Title",
            dataIndex: "file_name",
            key: "file_name",
            render: (text) => {
              const words = text.split(" ");
              const shortText = words.slice(0, 20).join(" ");
              const isTruncated = words.length > 20;

              return (
                <Tooltip title={text}>
                  <span
                    style={{
                      width: "200px",
                      display: "inline-block",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {isTruncated ? shortText + "..." : text}
                  </span>
                </Tooltip>
              );
            },
          },
          {
            title: "File Type",
            dataIndex: "file_type",
            key: "file_type",
            render: (text) => (
              <Tag color={text === "PDF" ? "green" : "blue"}>{text}</Tag>
            ),
          },
          {
            title: "Created At",
            dataIndex: "created",
            key: "created",
            render: (text) => <span>{text}</span>, // text here will be the formatted date
          },
          {
            title: "Duplitext Score (match percentage )",
            key: "copyscape",
            render: (_, record) =>
              record?.copyscape?.percent ? (
                <Button
                  onClick={() => handleOpenDuplitext(record?.copyscape?.uid)}
                  type="link"
                >
                  {`${record?.copyscape?.percent}%`}
                </Button>
              ) : (
                <div style={{ marginLeft: "20px" }}>N/A</div>
              ),
          },
          ...(activeKey === "1"
            ? [
                {
                  title: "Referencing Errors",
                  key: "referencing_errors",
                  render: (_, record) =>
                    record?.reference_issues?.length > 0 ? (
                      <Button
                        style={{ width: "100%" }}
                        onClick={() => handleReferencingModalVisible(record)}
                        type="link"
                      >
                        <span style={{ textAlign: "center" }}>View</span>
                      </Button>
                    ) : (
                      <div style={{ textAlign: "center" }}>N/A</div>
                    ),
                },
              ]
            : []),
          ...(activeKey === "1"
            ? [
                {
                  title: "Feedback Evaluation",
                  key: "feedback_report",
                  render: (_, record) =>
                    record?.feedback_report?.length > 0 ? (
                      <Button
                        style={{ width: "100%" }}
                        onClick={() => handleFeedbackModalVisible(record)}
                        type="link"
                      >
                        <span style={{ textAlign: "center" }}>View</span>
                      </Button>
                    ) : (
                      <div style={{ textAlign: "center" }}>N/A</div>
                    ),
                },
                {
                  title: "Remarks",
                  key: "remarks",
                  render: (_, record) =>
                    record?.remarks ? (
                      <Tooltip title={record.remarks}>
                        <Button type="link">
                          <span style={{ textAlign: "center" }}>View</span>
                        </Button>
                      </Tooltip>
                    ) : (
                      <div style={{ textAlign: "center" }}>N/A</div>
                    ),
                },
              ]
            : []),
          {
            title: "Download",
            key: "download",
            render: (_, record) => (
              <a
                href={record.file_url}
                download
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#1890ff" }}
              >
                <DownloadOutlined />
              </a>
            ),
          },
          //   ]
          // : [])
          // ,
          // ]
          //   :[]),
          ...(hasPermission("can_view_order_action_delete_solutions")
            ? [
                {
                  title: "Action",
                  key: "actions",
                  render: (_, record) =>
                    deletingFileUid === record.file_uid ? (
                      <Spin size="small" />
                    ) : (
                      <DeleteOutlined
                        style={{ color: "red", cursor: "pointer" }}
                        onClick={() =>
                          Modal.confirm({
                            title: "Delete File",
                            content:
                              "Are you sure you want to delete this file?",
                            okText: "Yes",
                            cancelText: "No",
                            okButtonProps: { danger: true },
                            onOk: () =>
                              handleDelete(
                                orderKey,
                                [record.file_uid],
                                activeKey
                              ),
                          })
                        }
                      />
                    ),
                },
              ]
            : []),
        ]}
        dataSource={formattedData} // Use the formatted data here
        pagination={false}
        bordered
        locale={{ emptyText: <Empty description="No Files" /> }}
      />
    );
  };

  const handleSubmissionClicked = () => {
    setIsModalVisible(true);
  };

  const handleTabClick = (key) => {
    setActiveKey(key);
  };
  const handleReferencingModalVisible = (record) => {
    setReferencingIssuesData(record);
    setIsReferencingModalVisible(true);
  };

  const handleOpenMetaFile = (file) => {
    setMetaFileData(file);
    setIsMetaFileModalVisible(true);
  };

  const handleCloseMetaFile = () => {
    setMetaFileData(null);
    setIsMetaFileModalVisible(false);
  };

  const handleFeedbackModalVisible = (record) => {
    setFeedbackReportData(record);
    setIsFeedbackModalVisible(true);
  };

  const ReferencingTable = () => {
    const columns = [
      {
        title: "Issue",
        dataIndex: "key",
        render: (index) => index + 1,
        width: "5%",
        align: "center",
      },
      {
        title: "Severity",
        dataIndex: "Severity",
        width: "10%",
        render: (text) => {
          return (
            <Tag
              style={{ backgroundColor: text === "Minor" ? "yellow" : "red" }}
            >
              {text}
            </Tag>
          );
        },
        align: "center",
      },
      {
        title: "Reference",
        dataIndex: "Reference",
        render: (text) => <div style={{ wordBreak: "break-word" }}>{text}</div>,
        width: "50%",
        align: "start",
      },
      {
        title: "Issue Type",
        dataIndex: "Issue Type",
        width: "20%",
        align: "center",
      },
      {
        title: "Category",
        dataIndex: "Category",
        width: "15%",
        render: (text) => (
          <Tag color="blue" style={{ wordBreak: "break-word" }}>
            {text}
          </Tag>
        ),
        align: "center",
      },
    ];

    const data = referencingIssuesData?.reference_issues?.map(
      (issue, index) => ({
        key: index,
        ...issue,
      })
    );

    return (
      <div
        style={{
          maxHeight: "400px",
          overflowY: "auto",
          padding: "10px",
        }}
      >
        <Table
          columns={columns}
          dataSource={data}
          pagination={false}
          bordered
          rowClassName="table-row"
        />
        {referencingIssuesData?.remarks && (
          <p>
            <strong>Remarks:</strong> {referencingIssuesData?.reference_remarks}
          </p>
        )}
        {referencingIssuesData?.reference_guide &&
          referencingIssuesData?.reference_source && (
            <Collapse accordion defaultActiveKey={[]} expandIconPosition="end">
              <Panel header="View Reference Guide and Sources" key="1">
                <p>
                  <strong>Reference Guide:</strong>{" "}
                  {referencingIssuesData?.reference_guide}
                </p>
                <p>
                  <strong>Reference Source:</strong>{" "}
                  {referencingIssuesData?.reference_source}
                </p>
              </Panel>
            </Collapse>
          )}
      </div>
    );
  };

  const ReferencingMobileTable = () => {
    const data = referencingIssuesData?.reference_issues?.map(
      (issue, index) => ({
        key: index,
        ...issue,
      })
    );

    return (
      <div
        style={{
          maxHeight: "400px",
          overflowY: "auto",
          padding: "10px",
        }}
      >
        {data?.length > 0 ? (
          data?.map((issue, index) => (
            <Card
              key={issue.key}
              title={`Issue ${index + 1}`}
              style={{
                borderRadius: "8px",
                border: "1px solid #ddd",
                marginBottom: "10px",
              }}
              bodyStyle={{ padding: "0px" }}
            >
              <Descriptions size="small" column={2} bordered>
                <Descriptions.Item label="Severity" span={2}>
                  <Tag
                    style={{
                      backgroundColor:
                        issue.Severity === "Minor" ? "yellow" : "red",
                    }}
                  >
                    {issue.Severity}
                  </Tag>
                </Descriptions.Item>
                <Descriptions.Item label="Reference" span={2}>
                  {issue.Reference}
                </Descriptions.Item>
                <Descriptions.Item label="Category" span={2}>
                  {issue.Category}
                </Descriptions.Item>

                <Descriptions.Item label="Issue Type" span={2}>
                  <Tag color="blue">{issue["Issue Type"]}</Tag>
                </Descriptions.Item>
              </Descriptions>
            </Card>
          ))
        ) : (
          <Empty description="No Referencing Errors" />
        )}
        {data?.length > 0 && (
          <>
            <p>
              <strong>Remarks:</strong>{" "}
              {referencingIssuesData?.reference_remarks}
            </p>
            {referencingIssuesData?.reference_guide &&
              referencingIssuesData?.reference_source && (
                <Collapse
                  accordion
                  defaultActiveKey={[]}
                  expandIconPosition="end"
                >
                  <Panel header="View Reference Guide and Sources " key="1">
                    <p>
                      <strong>Reference Guide:</strong>{" "}
                      {referencingIssuesData?.reference_guide}
                    </p>
                    <p>
                      <strong>Reference Source:</strong>{" "}
                      {referencingIssuesData?.reference_source}
                    </p>
                  </Panel>
                </Collapse>
              )}
          </>
        )}
      </div>
    );
  };




const getAllSolutionMetas = () => {
  return Array.isArray(solutionDetails)
    ? solutionDetails
    : [];
};





const SolutionMetaAllDesktop = () => {
  const metas = getAllSolutionMetas();
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  if (!metas || !metas.length) {
    return <Empty description="No Solution Metadata Found" />;
  }

  const handleViewFiles = (id) => {
    setExpandedRowKeys((prev) =>
      prev.includes(id) ? [] : [id] // allow only one open at a time
    );
  };

  return (
    <Table
      bordered
      pagination={false}
      rowKey="id"
      expandedRowKeys={expandedRowKeys}
      onExpand={() => {}}
      expandable={{
        expandIcon: () => null, // ❌ REMOVE + / - ICON
        expandIconColumnIndex: -1, // 🔥 FIX
        expandedRowRender: (meta) => (
          <div>
            <Typography.Title level={5}>Files</Typography.Title>

            {meta.files?.length ? (
              <Table
                bordered
                pagination={false}
                rowKey="file_uid"
                dataSource={meta.files}
                columns={[
                  {
                    title: "File Name",
                    dataIndex: "file_name",
                    render: (text, record) => (
                      <Button
                        type="link"
                        onClick={() => handleOpenMetaFile(record)}
                      >
                        {text}
                      </Button>
                    ),
                  },
                  {
                    title: "Type",
                    dataIndex: "file_type",
                    render: (t) => <Tag>{t}</Tag>,
                  },
                  {
                    title: "Created",
                    dataIndex: "created",
                    render: (t) =>
                      moment(t).local().format("YYYY-MM-DD hh:mm A"),
                  },
                  {
                    title: "Finalised",
                    dataIndex: "is_finalised",
                    render: (v) => <Checkbox checked={v} disabled />,
                  },
                  {
                    title: "Remarks",
                    dataIndex: "remarks",
                    render: (t) => t || "-",
                  },
                  {
                    title: "Download",
                    render: (_, r) => (
                      <a
                        href={r.file_url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <DownloadOutlined />
                      </a>
                    ),
                  },
                ]}
              />
            ) : (
              <Empty description="No Files" />
            )}
          </div>
        ),
      }}
      columns={[
        {
          title: "Author",
          render: (_, m) => m.author || "-",
        },
        {
          title: "Created At",
          render: (_, m) =>
            moment(m.created_at).local().format("YYYY-MM-DD hh:mm A"),
        },
        {
          title: "Task Type",
          render: (_, m) => m.task_type || "-",
        },
        {
          title: "Word Count Achieved",
          render: (_, m) => m.word_count_achieved ?? "-",
        },
        {
          title: "English Country",
          render: (_, m) => m.english_country || "-",
        },
        {
          title: "Referencing Format",
          render: (_, m) => m.referencing_format || "-",
        },
        {
          title: "Submission File Format",
          render: (_, m) => m.submission_file_format || "-",
        },
        {
          title: "AI Report Added",
          align: "center",
          render: (_, m) => <Checkbox checked={m.ai_report_added} disabled />,
        },
        {
          title: "Plag Report Added",
          align: "center",
          render: (_, m) => <Checkbox checked={m.plag_report_added} disabled />,
        },
        // {
        //   title: "Quality Check",
        //   align: "center",
        //   render: (_, m) => (
        //     <Checkbox checked={m.quality_check_completed} disabled />
        //   ),
        // },
        // {
        //   title: "Grammarly",
        //   align: "center",
        //   render: (_, m) => (
        //     <Checkbox checked={m.grammarly_check_completed} disabled />
        //   ),
        // },
        // {
        //   title: "Proofreading",
        //   align: "center",
        //   render: (_, m) => (
        //     <Checkbox checked={m.proofreading_completed} disabled />
        //   ),
        // },
        {
          title: "Author Details Removed",
          align: "center",
          render: (_, m) => (
            <Checkbox checked={m.author_details_removed} disabled />
          ),
        },
        {
          title: "Remark",
          render: (_, m) => m.remark || "-",
        },
        {
          title: "Files",
          align: "center",
          render: (_, m) =>
            m.files?.length ? (
              <Button
                type="link"
                icon={<FolderOpenOutlined />}
                onClick={() => handleViewFiles(m.id)}
              >
                View Files
              </Button>
            ) : (
              <span style={{ color: "#999" }}>No Files</span>
            ),
        },
        {
          title: "Status",
          align: "center",
          render: (_, m) =>
            m.is_active ? <Tag color="green">Active</Tag> : "-",
        },
      ]}
      dataSource={metas}
    />
  );
};

const SolutionMetaAllMobile = () => {
  const metas = getAllSolutionMetas();

  if (!metas.length) {
    return <Empty description="No Solution Metadata Found" />;
  }

  return (
    <Collapse accordion>
      {metas.map((meta) => (
        <Collapse.Panel
          key={meta.id}
          header={
            <span>
              Solution ID #{meta.id}{" "}
              {meta.is_active && <Tag color="green">Active</Tag>}
            </span>
          }
        >
          {/* META DETAILS */}
          <Descriptions bordered column={1} size="small">
            <Descriptions.Item label="Author">{meta.author}</Descriptions.Item>
            <Descriptions.Item label="Created At">
              {moment(meta.created_at).local().format("YYYY-MM-DD hh:mm A")}
            </Descriptions.Item>
            <Descriptions.Item label="Task Type">{meta.task_type}</Descriptions.Item>
            <Descriptions.Item label="Word Count Achieved">
              {meta.word_count_achieved}
            </Descriptions.Item>
            <Descriptions.Item label="English Country">
              {meta.english_country}
            </Descriptions.Item>
            <Descriptions.Item label="Referencing Format">
              {meta.referencing_format}
            </Descriptions.Item>
            <Descriptions.Item label="Submission File Format">
              {meta.submission_file_format}
            </Descriptions.Item>
            <Descriptions.Item label="AI Report Added">
              {meta.ai_report_added ? "Yes" : "No"}
            </Descriptions.Item>
            <Descriptions.Item label="Plag Report Added">
              {meta.plag_report_added ? "Yes" : "No"}
            </Descriptions.Item>
            {/* <Descriptions.Item label="Quality Check Completed">
              {meta.quality_check_completed ? "Yes" : "No"}
            </Descriptions.Item>
            <Descriptions.Item label="Grammarly Check Completed">
              {meta.grammarly_check_completed ? "Yes" : "No"}
            </Descriptions.Item>
            <Descriptions.Item label="Proofreading Completed">
              {meta.proofreading_completed ? "Yes" : "No"}
            </Descriptions.Item> */}
            <Descriptions.Item label="Author Details Removed">
              {meta.author_details_removed ? "Yes" : "No"}
            </Descriptions.Item>
            <Descriptions.Item label="Remark">
              {meta.remark || "-"}
            </Descriptions.Item>
          </Descriptions>

          {/* FILES */}
          <div style={{ marginTop: 16 }}>
            <Typography.Title level={5}>Files</Typography.Title>
            {meta.files?.length > 0 ? (
              <Table
                bordered
                pagination={false}
                rowKey="file_uid"
                dataSource={meta.files}
                columns={[
                  {
                    title: "File Name",
                    dataIndex: "file_name",
                    render: (text, record) => (
                      <Button type="link" onClick={() => handleOpenMetaFile(record)}>
                        {text}
                      </Button>
                    ),
                  },
                  {
                    title: "Type",
                    dataIndex: "file_type",
                    render: (t) => <Tag>{t}</Tag>,
                  },
                  {
                    title: "Created",
                    dataIndex: "created",
                    render: (t) =>
                      moment(t).local().format("YYYY-MM-DD hh:mm A"),
                  },
                  {
                    title: "Finalised",
                    dataIndex: "is_finalised",
                    render: (v) =>
                      v ? <Tag color="green">Yes</Tag> : "No",
                  },
                  {
                    title: "Remarks",
                    dataIndex: "remarks",
                    render: (t) => t || "-",
                  },
                  {
                    title: "Download",
                    render: (_, r) => (
                      <a
                        href={r.file_url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <DownloadOutlined />
                      </a>
                    ),
                  },
                ]}
              />
            ) : (
              <Empty description="No Files" />
            )}
          </div>
        </Collapse.Panel>
      ))}
    </Collapse>
  );
};



  return (
    <div style={{ padding: 20, border: "none" }}>
      <Tabs
        activeKey={activeKey}
        onTabClick={handleTabClick}
        tabBarExtraContent={
          !isMobile && hasPermission("can_create_duplitext_submissions") ? (
            <Button
              style={{
                background: "#36c6d3",
                color: "white",
                border: "none",
                marginTop: "1rem", // Add space between the button and tabs
              }}
              onClick={handleSubmissionClicked}
            >
              Duplitext Submission
            </Button>
          ) : null
        }
        className="solution-tabs"
        tabBarGutter={10}
        tabBarStyle={{ boxShadow: "none" }}
        renderTabBar={(props, DefaultTabBar) => (
          <div style={{ padding: "5px", border: "none", boxShadow: "none" }}>
            <DefaultTabBar
              style={{ border: "none", background: "yellow" }}
              {...props}
            />
          </div>
        )}
      >
        <TabPane
          tab={
            <span
              style={{
                padding: "8px 20px",
                fontWeight: 400,
                borderRadius: "20px",
                backgroundColor: activeKey === "1" ? "#001529" : "transparent",
                color: activeKey === "1" ? "whitesmoke" : "#000000",
                boxShadow:
                  activeKey === "1" ? "0 4px 8px rgba(0, 0, 0, 0.1)" : "none",
              }}
            >
              Final Files
            </span>
          }
          key="1"
          style={{ textAlign: "center" }}
        >
          {isMobile ? (
            <SolutionFilesMobile
              finalFilesData={finalFilesData}
              activeKey={activeKey}
              handleDelete={handleDelete}
              handleSubmissionClicked={handleSubmissionClicked}
              isClientVerified={isClientVerified}
              setIsReferencingModalVisible={setIsReferencingModalVisible}
              setReferencingIssuesData={setReferencingIssuesData}
              setIsFeedbackModalVisible={setIsFeedbackModalVisible}
              setFeedbackReportData={setFeedbackReportData}
              handleOpenDuplitext={handleOpenDuplitext}
            />
          ) : (
            renderTable(finalFilesData)
          )}
        </TabPane>
        <TabPane
          tab={
            <span
              style={{
                padding: "8px 20px",
                fontWeight: 400,
                borderRadius: "20px",
                backgroundColor: activeKey === "2" ? "#001529" : "transparent",
                color: activeKey === "2" ? "whitesmoke" : "#000000",
                boxShadow:
                  activeKey === "2" ? "0 4px 8px rgba(0, 0, 0, 0.1)" : "none",
              }}
            >
              Similarity Files
            </span>
          }
          key="2"
          style={{ textAlign: "center" }}
        >
          {isMobile ? (
            <SolutionFilesMobile
              similarityReportData={similarityReportData}
              activeKey={activeKey}
              handleDelete={handleDelete}
              handleSubmissionClicked={handleSubmissionClicked}
              setIsReferencingModalVisible={setIsReferencingModalVisible}
              handleOpenDuplitext={handleOpenDuplitext}
            />
          ) : (
            renderTable(similarityReportData)
          )}
        </TabPane>
        <TabPane
          tab={
            <span
              style={{
                padding: "8px 20px",
                fontWeight: 400,
                borderRadius: "20px",
                backgroundColor: activeKey === "3" ? "#001529" : "transparent",
                color: activeKey === "3" ? "whitesmoke" : "#000000",
                boxShadow:
                  activeKey === "3" ? "0 4px 8px rgba(0, 0, 0, 0.1)" : "none",
              }}
            >
              Other Files
            </span>
          }
          key="3"
          style={{ textAlign: "center" }}
        >
          {isMobile ? (
            <SolutionFilesMobile
              otherFilesData={otherFilesData}
              activeKey={activeKey}
              handleDelete={handleDelete}
              handleSubmissionClicked={handleSubmissionClicked}
              setIsReferencingModalVisible={setIsReferencingModalVisible}
              setReferencingIssuesData={setReferencingIssuesData}
              handleOpenDuplitext={handleOpenDuplitext}
            />
          ) : (
            renderTable(otherFilesData)
          )}
        </TabPane>
        <TabPane
          tab={
            <span
              style={{
                padding: "8px 20px",
                fontWeight: 400,
                borderRadius: "20px",
                backgroundColor: activeKey === "4" ? "#001529" : "transparent",
                color: activeKey === "4" ? "whitesmoke" : "#000000",
                boxShadow:
                  activeKey === "4" ? "0 4px 8px rgba(0, 0, 0, 0.1)" : "none",
              }}
            >
              Solution Meta
            </span>
          }
          key="4"
          style={{ textAlign: "center" }}
        >
          {isMobile ? <SolutionMetaAllMobile /> : <SolutionMetaAllDesktop /> }

        </TabPane>
      </Tabs> 
      {isModalVisible && (
        <Modal
          className="custom-modal"
          title={
            <div className="custom-modal-header">
              <Typography.Title
                style={{
                  color: "white",
                  marginLeft: "15px",
                  position: "relative",
                  fontSize: "clamp(14px, 3vw, 20px)",
                  top: "-5px",
                  padding: "0px",
                }}
              >
                Duplitext Submission
              </Typography.Title>
            </div>
          }
          onCancel={() => setIsModalVisible(false)}
          okText="Submit"
          visible={isModalVisible}
          footer={null}
          height={500}
          width={900}
        >
          <DupliTextParent />
        </Modal>
      )}

      {isDuplitextVisible && (
        <Modal
          className="custom-modal"
          title={
            <div className="custom-modal-header">
              <Typography.Title
                style={{
                  color: "white",
                  marginLeft: "15px",
                  position: "relative",
                  fontSize: "clamp(14px, 3vw, 20px)",
                  top: "-5px",
                  padding: "0px",
                }}
              >
                Duplitext Report
              </Typography.Title>
            </div>
          }
          onCancel={() => setIsDuplitextVisible(false)}
          okText="Submit"
          visible={isDuplitextVisible}
          footer={null}
          width={900}
          height={500}
        >
          <DupliTextDetail uid={copyscapeUid} />
        </Modal>
      )}

      {/* Refrencing Styles Modal */}
      {isReferencingModalVisible && (
        <Modal
          maskClosable={false}
          className="custom-modal"
          title={
            <div className="custom-modal-header">
              <Typography.Title
                style={{
                  color: "white",
                  marginLeft: "15px",
                  position: "relative",
                  fontSize: "clamp(14px, 3vw, 20px)",
                  top: "-5px",
                  padding: "0px",
                }}
              >
                Referencing Styles Errors
              </Typography.Title>
            </div>
          }
          onCancel={() => setIsReferencingModalVisible(false)}
          okText="Submit"
          visible={isReferencingModalVisible}
          footer={null}
          height={500}
          width={1200}
        >
          {isMobile ? <ReferencingMobileTable /> : <ReferencingTable />}
        </Modal>
      )}

      {/* Feedback modal */}
      {isFeedbackModalVisible && (
        <Modal
          maskClosable={false}
          className="custom-modal"
          title={
            <div className="custom-modal-header">
              <Typography.Title
                style={{
                  color: "white",
                  marginLeft: "15px",
                  position: "relative",
                  fontSize: "clamp(14px, 3vw, 20px)",
                  top: "-5px",
                  padding: "0px",
                }}
              >
                Feedback Evaluation
              </Typography.Title>
            </div>
          }
          onCancel={() => setIsFeedbackModalVisible(false)}
          okText="Submit"
          visible={isFeedbackModalVisible}
          footer={null}
          height={500}
          width={1200}
        >
          {isMobile ? (
            <FeedbackEvalMobile feedbackReportData={feedbackReportData} />
          ) : (
            <FeedbbackDesktop feedbackReportData={feedbackReportData} />
          )}
        </Modal>
      )}
      {isMetaFileModalVisible && (
        <Modal
          maskClosable={false}
          className="custom-modal"
          title={
            <div className="custom-modal-header">
              <Typography.Title
                style={{
                  color: "white",
                  marginLeft: "15px",
                  position: "relative",
                  fontSize: "clamp(14px, 3vw, 20px)",
                  top: "-5px",
                  padding: "0px",
                }}
              >
                File Details
              </Typography.Title>
            </div>
          }
          onCancel={handleCloseMetaFile}
          visible={isMetaFileModalVisible}
          footer={null}
          width={900}
        >
          {metaFileData ? (
            <div>
              <Descriptions bordered column={1} size="small">
                <Descriptions.Item label="File Name">{metaFileData.file_name}</Descriptions.Item>
                <Descriptions.Item label="File Type">{metaFileData.file_type}</Descriptions.Item>
                <Descriptions.Item label="Created At">{metaFileData.created ? moment(metaFileData.created).local().format("YYYY-MM-DD hh:mm A") : "-"}</Descriptions.Item>
                <Descriptions.Item label="Remarks">{metaFileData.remarks || "-"}</Descriptions.Item>
                <Descriptions.Item label="Finalised">{metaFileData.is_finalised ? "Yes" : "No"}</Descriptions.Item>
                <Descriptions.Item label="Download">
                  <a href={metaFileData.file_url} download target="_blank" rel="noopener noreferrer">
                    Download
                  </a>
                </Descriptions.Item>
              </Descriptions>

              {metaFileData.file_url && metaFileData.file_url.toLowerCase().endsWith(".pdf") && (
                <div style={{ marginTop: 12 }}>
                  <iframe
                    title="pdf-preview"
                    src={metaFileData.file_url}
                    style={{ width: "100%", height: 400, border: "none" }}
                  />
                </div>
              )}
            </div>
          ) : null}
        </Modal>
      )}
    </div>
  );
};

export default SolutionFilesAccordion;
